import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
interface CountdownTimerProps {
  initialSeconds?: number;
  className?: string;
}
export function CountdownTimer({
  initialSeconds = 7200,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className={`flex items-center justify-center space-x-2 text-wellness-red font-semibold bg-red-50 py-2 px-4 rounded-lg border border-red-100 ${className}`} data-id="element-14">
      <ClockIcon className="w-5 h-5 animate-pulse" data-id="element-15" />
      <span className="text-lg tracking-wider font-body" data-id="element-16">
        {formatTime(timeLeft)}
      </span>
    </div>;
}